import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '@/store/store';

export type ExperimentsState = {
  netPositionLnWHandling?: string;
  gameSwitchEnabled?: string | boolean;
};

const initialState: ExperimentsState = {
  netPositionLnWHandling: 'enabled',
  gameSwitchEnabled: false,
};

const amplitudeSlice = createSlice({
  name: 'amplitudeExperiments',
  initialState,
  reducers: {
    setExperiments: (state, action: PayloadAction<ExperimentsState>) => ({
      ...state,
      ...action.payload,
    }),
  },
});

export const amplitudeContextSelector = (state: RootState) =>
  state.amplitudeExperiments;
export const { setExperiments } = amplitudeSlice.actions;

export const amplitudeContextReducer = amplitudeSlice.reducer;
